export const scdPickerDialogTableSettings = {
  displayedColumns: ['check', 'name', 'surname', 'email', 'department'],
};
